"use strict";

theme.announcementBar = (function () {
  var args = {
    autoPlay: 5000,
    avoidReflow: true,
    cellAlign: theme.config.rtl ? "right" : "left",
  };
  var bar;
  var flickity;

  function init() {
    bar = document.getElementById("AnnouncementSlider");
    if (!bar) {
      return;
    }

    unload();

    if (bar.dataset.blockCount === 1) {
      return;
    }

    if (theme.config.bpSmall || bar.dataset.compact === "true") {
      initSlider();
    }

    document.addEventListener("matchSmall", function () {
      unload();
      initSlider();
    });

    document.addEventListener("unmatchSmall", function () {
      unload();
      if (bar.dataset.compact === "true") {
        initSlider();
      }
    });
  }

  function initSlider() {
    flickity = new theme.Slideshow(bar, args);
  }

  // Go to slide if selected in the editor
  function onBlockSelect(id) {
    var slide = bar.querySelector("#AnnouncementSlide-" + id);
    var index = parseInt(slide.dataset.index);

    if (flickity && typeof flickity.pause === "function") {
      flickity.goToSlide(index);
      flickity.pause();
    }
  }

  function onBlockDeselect() {
    if (flickity && typeof flickity.play === "function") {
      flickity.play();
    }
  }

  function unload() {
    if (flickity && typeof flickity.destroy === "function") {
      flickity.destroy();
    }
  }

  return {
    init: init,
    onBlockSelect: onBlockSelect,
    onBlockDeselect: onBlockDeselect,
    unload: unload,
  };
})();

theme.headerNav = (function () {
  var selectors = {
    wrapper: "#HeaderWrapper",
    siteHeader: "#SiteHeader",
    searchBtn: ".js-search-header",
    closeSearch: "#SearchClose",
    searchContainer: ".site-header__search-container",
    logo: "#LogoContainer img",
    megamenu: ".megamenu",
    navItems: ".site-nav__item",
    navLinks: ".site-nav__link",
    navLinksWithDropdown: ".site-nav__link--has-dropdown",
    navDropdownLinks: ".site-nav__dropdown-link--second-level",
  };

  var classes = {
    hasDropdownClass: "site-nav--has-dropdown",
    hasSubDropdownClass: "site-nav__deep-dropdown-trigger",
    dropdownActive: "is-focused",
  };

  var config = {
    namespace: ".siteNav",
    wrapperOverlayed: false,
    overlayedClass: "is-light",
    overlayEnabledClass: "header-wrapper--sticky",
    stickyEnabled: false,
    stickyActive: false,
    stickyClass: "site-header--stuck",
    stickyHeaderWrapper: "StickyHeaderWrap",
    openTransitionClass: "site-header--opening",
    lastScroll: 0,
  };

  // Elements used in resize functions, defined in init
  var wrapper;
  var siteHeader;

  function init() {
    wrapper = document.querySelector(selectors.wrapper);
    siteHeader = document.querySelector(selectors.siteHeader);

    config.stickyEnabled = siteHeader.dataset.sticky === "true";
    if (config.stickyEnabled) {
      config.wrapperOverlayed = wrapper.classList.contains(
        config.overlayedClass,
      );
      stickyHeaderCheck();
    }

    theme.settings.overlayHeader = siteHeader.dataset.overlay === "true";
    // Disable overlay header if on collection template with no collection image
    if (theme.settings.overlayHeader && Shopify && Shopify.designMode) {
      if (
        document.body.classList.contains("template-collection") &&
        !document.querySelector(".collection-hero")
      ) {
        this.disableOverlayHeader();
      }
    }

    accessibleDropdowns();
    searchDrawer();

    window.on("load" + config.namespace, resizeLogo);
    window.on(
      "resize" + config.namespace,
      theme.utils.debounce(150, resizeLogo),
    );
  }

  // If the header setting to overlay the menu on the collection image
  // is enabled but the collection setting is disabled, we need to undo
  // the init of the sticky nav
  function disableOverlayHeader() {
    wrapper.classList.remove(
      config.overlayEnabledClass,
      config.overlayedClass,
    );
    config.wrapperOverlayed = false;
    theme.settings.overlayHeader = false;
  }

  function stickyHeaderCheck() {
    // Disable sticky header if any mega menu is taller than window
    theme.config.stickyHeader = doesMegaMenuFit();

    if (theme.config.stickyHeader) {
      config.forceStopSticky = false;
      stickyHeader();
    } else {
      config.forceStopSticky = true;
    }
  }

  function doesMegaMenuFit() {
    var largestMegaNav = 0;
    siteHeader.querySelectorAll(selectors.megamenu).forEach((nav) => {
      var h = nav.offsetHeight;
      if (h > largestMegaNav) {
        largestMegaNav = h;
      }
    });

    // 120 ~ space of visible header when megamenu open
    if (window.innerHeight < largestMegaNav + 120) {
      return false;
    }

    return true;
  }

  function stickyHeader() {
    config.lastScroll = 0;

    var wrapWith = document.createElement("div");
    wrapWith.id = config.stickyHeaderWrapper;
    theme.utils.wrap(siteHeader, wrapWith);

    stickyHeaderHeight();

    window.on(
      "resize" + config.namespace,
      theme.utils.debounce(50, stickyHeaderHeight),
    );
    window.on(
      "scroll" + config.namespace,
      theme.utils.throttle(20, stickyHeaderScroll),
    );

    // This gets messed up in the editor, so here's a fix
    if (Shopify && Shopify.designMode) {
      setTimeout(function () {
        stickyHeaderHeight();
      }, 250);
    }
  }

  function stickyHeaderHeight() {
    if (!config.stickyEnabled) {
      return;
    }
    var h = siteHeader.offsetHeight;
    var stickyHeader = document.querySelector(
      "#" + config.stickyHeaderWrapper,
    );
    stickyHeader.style.height = h + "px";
  }

  function stickyHeaderScroll() {
    if (!config.stickyEnabled) {
      return;
    }

    if (config.forceStopSticky) {
      return;
    }

    requestAnimationFrame(scrollHandler);

    config.lastScroll = window.scrollY;
  }

  function scrollHandler() {
    if (window.scrollY > 250) {
      if (config.stickyActive) {
        return;
      }

      config.stickyActive = true;

      siteHeader.classList.add(config.stickyClass);
      if (config.wrapperOverlayed) {
        wrapper.classList.remove(config.overlayedClass);
      }

      // Add open transition class after element is set to fixed
      // so CSS animation is applied correctly
      setTimeout(function () {
        siteHeader.classList.add(config.openTransitionClass);
      }, 100);
    } else {
      if (!config.stickyActive) {
        return;
      }

      config.stickyActive = false;

      siteHeader.classList.remove(config.openTransitionClass);
      siteHeader.classList.remove(config.stickyClass);
      if (config.wrapperOverlayed) {
        wrapper.classList.add(config.overlayedClass);
      }
    }
  }

  function accessibleDropdowns() {
    var hasActiveDropdown = false;
    var hasActiveSubDropdown = false;
    var closeOnClickActive = false;

    // Touch devices open dropdown on first click, navigate to link on second
    if (theme.config.isTouch) {
      document
        .querySelectorAll(selectors.navLinksWithDropdown)
        .forEach((el) => {
          el.on("touchend" + config.namespace, function (evt) {
            var parent = evt.currentTarget.parentNode;
            if (!parent.classList.contains(classes.dropdownActive)) {
              evt.preventDefault();
              closeDropdowns();
              openFirstLevelDropdown(evt.currentTarget);
            } else {
              window.location.replace(evt.currentTarget.getAttribute("href"));
            }
          });
        });
    }

    // Open/hide top level dropdowns
    document.querySelectorAll(selectors.navLinks).forEach((el) => {
      el.on("focusin" + config.namespace, accessibleMouseEvent);
      el.on("mouseover" + config.namespace, accessibleMouseEvent);
      el.on("mouseleave" + config.namespace, closeDropdowns);
    });

    document.querySelectorAll(selectors.navDropdownLinks).forEach((el) => {
      if (theme.config.isTouch) {
        el.on("touchend" + config.namespace, function (evt) {
          var parent = evt.currentTarget.parentNode;

          // Open third level menu or go to link based on active state
          if (parent.classList.contains(classes.hasSubDropdownClass)) {
            if (!parent.classList.contains(classes.dropdownActive)) {
              evt.preventDefault();
              closeThirdLevelDropdown();
              openSecondLevelDropdown(evt.currentTarget);
            } else {
              window.location.replace(evt.currentTarget.getAttribute("href"));
            }
          } else {
            // No third level nav, go to link
            window.location.replace(evt.currentTarget.getAttribute("href"));
          }
        });
      }

      // Open/hide sub level dropdowns
      el.on("focusin" + config.namespace, function (evt) {
        closeThirdLevelDropdown();
        openSecondLevelDropdown(evt.currentTarget, true);
      });
    });

    // Clicking outside of the megamenu should close it
    if (theme.config.isTouch) {
      document.body.on("touchend" + config.namespace, function () {
        closeDropdowns();
      });

      // Exception to above: clicking anywhere on the megamenu content will NOT close it
      siteHeader.querySelectorAll(selectors.megamenu).forEach((el) => {
        el.on("touchend" + config.namespace, function (evt) {
          evt.stopImmediatePropagation();
        });
      });
    }

    function accessibleMouseEvent(evt) {
      if (hasActiveDropdown) {
        closeSecondLevelDropdown();
      }

      if (hasActiveSubDropdown) {
        closeThirdLevelDropdown();
      }

      openFirstLevelDropdown(evt.currentTarget);
    }

    // Private dropdown functions
    function openFirstLevelDropdown(el) {
      var parent = el.parentNode;
      if (parent.classList.contains(classes.hasDropdownClass)) {
        parent.classList.add(classes.dropdownActive);
        hasActiveDropdown = true;
      }

      if (!theme.config.isTouch) {
        if (!closeOnClickActive) {
          var eventType = theme.config.isTouch ? "touchend" : "click";
          closeOnClickActive = true;
          document.documentElement.on(
            eventType + config.namespace,
            function () {
              closeDropdowns();
              document.documentElement.off(eventType + config.namespace);
              closeOnClickActive = false;
            }.bind(this),
          );
        }
      }
    }

    function openSecondLevelDropdown(el, skipCheck) {
      var parent = el.parentNode;
      if (
        parent.classList.contains(classes.hasSubDropdownClass) ||
        skipCheck
      ) {
        parent.classList.add(classes.dropdownActive);
        hasActiveSubDropdown = true;
      }
    }

    function closeDropdowns() {
      closeSecondLevelDropdown();
      closeThirdLevelDropdown();
    }

    function closeSecondLevelDropdown() {
      document.querySelectorAll(selectors.navItems).forEach((el) => {
        el.classList.remove(classes.dropdownActive);
      });
    }

    function closeThirdLevelDropdown() {
      document.querySelectorAll(selectors.navDropdownLinks).forEach((el) => {
        el.parentNode.classList.remove(classes.dropdownActive);
      });
    }
  }

  function searchDrawer() {
    document.querySelectorAll(selectors.searchBtn).forEach((btn) => {
      btn.addEventListener("click", openSearchDrawer);
    });

    document
      .querySelector(selectors.closeSearch)
      .addEventListener("click", closeSearchDrawer);
  }

  function openSearchDrawer(evt) {
    evt.preventDefault();
    evt.stopImmediatePropagation();
    var container = document.querySelector(selectors.searchContainer);
    theme.utils.prepareTransition(
      container,
      function () {
        container.classList.add("is-active");
      }.bind(this),
    );

    document.documentElement.classList.add(
      "js-drawer-open",
      "js-drawer-open--search",
    );

    setTimeout(function () {
      theme.a11y.trapFocus({
        container: container,
        namespace: "header_search",
        elementToFocus: container.querySelector(".site-header__search-input"),
      });
    }, 100);

    // If sticky is enabled, scroll to top on mobile when close to it
    // so you don't get an invisible search box
    if (
      theme.config.bpSmall &&
      config.stickyEnabled &&
      config.lastScroll < 300
    ) {
      window.scrollTo(0, 0);
    }

    // Bind events
    theme.a11y.lockMobileScrolling(config.namespace);

    bindSearchEvents();
  }

  function closeSearchDrawer(evt) {
    // Do not close if click event came from inside drawer
    if (evt) {
      // evt.path is non-standard, so have fallback
      var path = evt.path || (evt.composedPath && evt.composedPath());
      for (var i = 0; i < path.length; i++) {
        if (path[i].classList) {
          if (path[i].classList.contains("site-header__search-btn")) {
            break;
          }

          if (path[i].classList.contains("site-header__search-container")) {
            return;
          }
        }
      }
    }

    // deselect any focused form elements
    document.activeElement.blur();

    document.documentElement.classList.add("js-drawer-closing");
    document.documentElement.classList.remove(
      "js-drawer-open",
      "js-drawer-open--search",
    );

    window.setTimeout(
      function () {
        document.documentElement.classList.remove("js-drawer-closing");
      }.bind(this),
      500,
    );

    var container = document.querySelector(selectors.searchContainer);
    theme.utils.prepareTransition(
      container,
      function () {
        container.classList.remove("is-active");
      }.bind(this),
    );

    theme.a11y.removeTrapFocus({
      container: container,
      namespace: "header_search",
    });

    theme.a11y.unlockMobileScrolling(config.namespace);

    unbindSearchEvents();
  }

  function bindSearchEvents() {
    window.on(
      "keyup" + config.namespace,
      function (evt) {
        if (evt.keyCode === 27) {
          closeSearchDrawer();
        }
      }.bind(this),
    );

    // Clicking out of container closes it
    document.documentElement.on(
      "click" + config.namespace,
      function (evt) {
        closeSearchDrawer(evt);
      }.bind(this),
    );
  }

  function unbindSearchEvents() {
    window.off("keyup" + config.namespace);
    document.documentElement.off("click" + config.namespace);
  }

  function resizeLogo(evt) {
    document.querySelectorAll(selectors.logo).forEach((logo) => {
      var logoWidthOnScreen = logo.clientWidth;
      var containerWidth = logo.closest(".header-item").clientWidth;

      // If image exceeds container, let's make it smaller
      if (logoWidthOnScreen > containerWidth) {
        logo.style.maxWidth = containerWidth;
      } else {
        logo.removeAttribute("style");
      }
    });
  }
  return {
    init: init,
    disableOverlayHeader: disableOverlayHeader,
  };
})();

theme.HeaderSection = (function () {
  var selectors = {
    locale: "[data-disclosure-locale]",
    currency: "[data-disclosure-currency]",
  };

  function HeaderSection(container) {
    this.container = container;
    this.sectionId = this.container.getAttribute("data-section-id");

    this.init();
  }

  HeaderSection.prototype = Object.assign({}, HeaderSection.prototype, {
    init: function () {
      // Reload any slideshow if header is reloaded to make sure
      // sticky header works as expected
      // (can be anywhere in sections.instance array)
      if (Shopify && Shopify.designMode) {
        theme.sections.reinit("slideshow-section");

        // Set a timer to resize the header in case the logo changes size
        setTimeout(function () {
          window.dispatchEvent(new Event("resize"));
        }, 500);
      }

      this.initDrawers();
      this.initDisclosures();
      theme.headerNav.init();
      theme.announcementBar.init();
    },

    initDisclosures: function () {
      var localeEl = this.container.querySelector(selectors.locale);
      var currencyEl = this.container.querySelector(selectors.currency);

      if (localeEl) {
        this.localeDisclosure = new theme.Disclosure(localeEl);
      }

      if (currencyEl) {
        this.currencyDisclosure = new theme.Disclosure(currencyEl);
      }
    },

    initDrawers: function () {
      theme.NavDrawer = new theme.Drawers("NavDrawer", "nav");
      if (theme.settings.cartType === "drawer") {
        if (!document.body.classList.contains("template-cart")) {
          new theme.CartDrawer();
        }
      }

      theme.collapsibles.init(document.getElementById("NavDrawer"));
    },

    onBlockSelect: function (evt) {
      theme.announcementBar.onBlockSelect(evt.detail.blockId);
    },

    onBlockDeselect: function () {
      theme.announcementBar.onBlockDeselect();
    },

    onUnload: function () {
      theme.NavDrawer.close();
      theme.announcementBar.unload();

      if (this.localeDisclosure) {
        this.localeDisclosure.destroy();
      }

      if (this.currencyDisclosure) {
        this.currencyDisclosure.destroy();
      }
    },
  });

  return HeaderSection;
})();

theme.FooterSection = (function () {
  var selectors = {
    locale: "[data-disclosure-locale]",
    currency: "[data-disclosure-currency]",
  };

  function FooterSection(container) {
    this.container = container;
    this.localeDisclosure = null;
    this.currencyDisclosure = null;

    this.init();
  }

  FooterSection.prototype = Object.assign({}, FooterSection.prototype, {
    init: function () {
      var localeEl = this.container.querySelector(selectors.locale);
      var currencyEl = this.container.querySelector(selectors.currency);

      if (localeEl) {
        this.localeDisclosure = new theme.Disclosure(localeEl);
      }

      if (currencyEl) {
        this.currencyDisclosure = new theme.Disclosure(currencyEl);
      }

      // Change email icon to submit text
      var newsletterInput = document.querySelector(
        ".footer__newsletter-input",
      );
      if (newsletterInput) {
        newsletterInput.addEventListener("keyup", function () {
          newsletterInput.classList.add("footer__newsletter-input--active");
        });
      }

      // Re-hook up collapsible box triggers
      theme.collapsibles.init(this.container);
    },

    onUnload: function () {
      if (this.localeDisclosure) {
        this.localeDisclosure.destroy();
      }

      if (this.currencyDisclosure) {
        this.currencyDisclosure.destroy();
      }
    },
  });

  return FooterSection;
})();

theme.PasswordHeader = (function () {
  function PasswordHeader() {
    this.init();
  }

  PasswordHeader.prototype = Object.assign({}, PasswordHeader.prototype, {
    init: function () {
      if (!document.querySelector("#LoginModal")) {
        return;
      }

      var passwordModal = new theme.Modals("LoginModal", "login-modal", {
        focusIdOnOpen: "password",
        solid: true,
      });

      // Open modal if errors exist
      if (document.querySelectorAll(".errors").length) {
        passwordModal.open();
      }
    },
  });

  return PasswordHeader;
})();

